import React from 'react';
import { Modal, Button, Form, Tag } from 'antd';
import { REGISTRADO, EMITIDO, RECHAZADO, ANULADO } from '../../../common/types/comprobanteEstadoType';

export default class CdrModal extends React.Component {
    renderColor = (item) => {
        if (item.idComprobanteEstado === REGISTRADO)
            return 'blue';
        if (item.idComprobanteEstado === EMITIDO)
            return 'green';
        if (item.idComprobanteEstado === RECHAZADO)
            return 'orange';
        if (item.idComprobanteEstado === ANULADO)
            return 'red';
    };

    item = (label, value) => {
        return (
            <div style={{ width: '100%', display: 'inline-flex', marginBottom: 8, background: '#fafafa' }}>
                <div style={{ width: '170px', color: '#242424', padding: 6 }}>
                    {label}
                </div>
                <div style={{ width: 'calc(100% - 170px)', padding: 6 }}>
                    {value}
                </div>
            </div>
        );
    }

    render() {
        return (
            <Modal
                title={"CDR Sunat"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={550}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cancelar
                    </Button>,
                    <Button
                        key="2"
                        type="primary"
                        onClick={this.props.onDownloadXml}
                    >
                        Descargar XML
                    </Button>,

                    <Button
                        key="3"
                        loading={this.props.loadingFile == undefined ? false : this.props.loadingFile}
                        type={this.props.item.respuestaSunat == null ? 'danger' : 'primary'}
                        onClick={this.props.item.respuestaSunat == null ? this.props.onGetCdr : this.props.onDownloadCdr}
                    >
                        {this.props.item.respuestaSunat == null ? 'Obtener CDR' : 'Descargar CDR'}
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            {this.item("Tipo de Comprobante:", this.props.item.nombreTipoComprobante)}
                            {this.item("Número de Documento:", this.props.item.numeroDocumentoCliente)}
                            {this.item("Fecha de Envio:", this.props.item.fechaEmisionStr)}
                            {this.item("Fecha de Respuesta:", this.props.item.fechaRespuestaStr)}
                            {this.item("Estado:",
                                <div className="custom-options" >
                                    <Tag color={this.renderColor(this.props.item)}>{this.props.item.nombreComprobanteEstado}</Tag>
                                </div>)}
                            {this.item("Respuesta Sunat:", this.props.item.respuestaSunat)}
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}